<div class="landing-wrapper">
  <div class="overlay"></div>

  <div class="landing-content">
    <h1 class="landing-title">Welcome To The Dealer Bidding System</h1>
    <div *ngIf="disclaimerText">
    <div class="secondary_title">Terms and Conditions</div>

      <p>
        {{ disclaimerText }}
      </p>
      <br />
      <p>
        <input type="checkbox" [(ngModel)]="policyAcknowledged" required />
        I have read and understood the BMW SA Dealer Bidding System Policy.
      </p>
      <br />
      <div class="form-row">
        <ds-form-field class="form-control">
          <label ds-label for="dropdown1" class="form-label"
          >Preferred Dealership</label
          >
          <ds-select
            id="dropdown1"
            [labellingConfig]="{ placeholder: 'Select your dealership' }"
            [options]="dealerOptions"
            [(ngModel)]="selectedDealer"
            required
          ></ds-select>
        </ds-form-field>

        <button
          ds-button
          type="button"
          variant="primary"
          class="continue-btn"
          [disabled]="!(policyAcknowledged && selectedDealer)"
          (click)="enterApp()"
        >
          Continue
        </button>
      </div>
      <br />
    </div>
    <br />
    <div *ngIf="errorMessage">
      <div class="secondary_title">{{ errorMessage }}</div>
    </div>
  </div>

  <ds-modal
    #userModal
    [ds-modal-trigger-for]="userModal"
    [(isModalOpen)]="newApplicationModalOpen"
    [dimensionsConfig]="{ width: '500px', height: 'auto' }"
    [detachFooter]="true">
    <ds-box-header style="font-size: xx-large; font-weight: bold">
      <h1>Request Access</h1>
    </ds-box-header>
    <ds-box-content>
      <div *ngIf="!requestSuccess; else successMsg" class="user-form">
        <div class="user-form">
          <div class="row gx-3">
            <div class="col-md-12 mb-3">
              <ds-form-field>
                <label ds-label class="form-label" for="namesInput">Names *</label>
                <input
                  id="namesInput"
                  ds-input
                  type="text"
                  required
                  [(ngModel)]="userForm.names"
                  placeholder="Enter Names"
                />
              </ds-form-field>
            </div>
            <div class="col-md-12 mb-3">
              <ds-form-field>
                <label ds-label class="form-label" for="dealerInput">Dealer *</label>
                <input
                  required
                  id="dealerInput"
                  ds-input
                  type="text"
                  [(ngModel)]="userForm.dealer"
                  placeholder="Enter Dealer"
                />
              </ds-form-field>
            </div>
            <div class="col-md-12 mb-3">
              <ds-form-field>
                <label ds-label class="form-label" for="dealerInput">Dealer Code *</label>
                <input
                  required
                  id="dealerInput"
                  ds-input
                  type="text"
                  [(ngModel)]="userForm.dealerCode"
                  placeholder="Enter Dealer"
                />
              </ds-form-field>
            </div>
            <div class="col-md-12 mb-3">
              <ds-form-field>
                <label ds-label class="form-label" for="cNumberInput">C-Number *</label>
                <input
                  id="cNumberInput"
                  ds-input
                  type="text"
                  required
                  [(ngModel)]="userForm.cNumber"
                  placeholder="Enter C-Number"
                />
              </ds-form-field>
            </div>
            <div class="col-md-12 mb-3">
              <ds-form-field>
                <label ds-label class="form-label" for="emailInput">Email *</label>
                <input
                  id="cNumberInput"
                  ds-input
                  type="text"
                  required
                  [(ngModel)]="userForm.email"
                  placeholder="Enter Email"
                />
              </ds-form-field>
            </div>
            <div class="col-md-12 mb-3">
              <ds-form-field>
                <label ds-label class="form-label" for="roleSelect">Role *</label>
                <ds-select
                  id="roleSelect"
                  [options]="roleOptions"
                  [(value)]="userForm.role"
                  required
                  [labellingConfig]="{ placeholder: 'Select Role' }"
                ></ds-select>
              </ds-form-field>
            </div>
          </div>
        </div>

      </div>
      <ng-template #successMsg>
        <div class="success-message">
          <h2>Request submitted successfully!</h2>
          <p>We will process your access request soon.</p>
        </div>
      </ng-template>
    </ds-box-content>
    <ds-box-footer *ngIf="!requestSuccess">
      <ds-button variant="primary"  [disabled]="!isAccessFormValid()" (click)="submitUserForm()">
        Request Access
      </ds-button>
    </ds-box-footer>
  </ds-modal>
</div>
